import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { stringify } from '@tools/stringify';

import { faArrowUpRightFromSquare } from '@icons/solid/faArrowUpRightFromSquare';

/**
 * `DisplayValue` component properties.
 */
export interface Props {
  /**
   * Value to display.
   */
  value?: unknown;
  /**
   * Text label that should accompany the displayed value.
   */
  label: string;
  /**
   * If `true`, the rendered text will be bolded.
   */
  bold?: boolean;
  /**
   * Target URL the displayed value should link to if clicked.
   */
  href?: string;
  /**
   * If `true`, capitalize "value"
   */
  capitalize?: boolean;
}


import { modals } from '@modals';

declare module 'vue/types/vue' {
  export interface Vue {
    DisplayValue: ComponentWithProps<Props>;
  }
}

function openUrl(link: string) {
  void modals.confirm.externalLinkNotice({ link });
}

const __default__ = { name: 'DisplayValue' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    value: null,
    label: null,
    bold: { type: Boolean },
    href: null,
    capitalize: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  /**
   * Value to display.
   */
  value?: unknown;
  /**
   * Text label that should accompany the displayed value.
   */
  label: string;
  /**
   * If `true`, the rendered text will be bolded.
   */
  bold?: boolean;
  /**
   * Target URL the displayed value should link to if clicked.
   */
  href?: string;
  /**
   * If `true`, capitalize "value"
   */
  capitalize?: boolean;
};



const displayValue = computed(() => {
  let value = stringify(props.value ?? '');

  if (props.capitalize) {
    value = value.toUpperCase();
  }

  return value;
});

return { __sfc: true,openUrl, props, displayValue, faArrowUpRightFromSquare }
}

})